<template>
    <section>
        <div class="point-is-done" v-if="point.is_done">
            <img class="point-is-done__img" src="../../assets/icons/panel/editSession/meeting-time.svg" />
            <span>{{$t('com.file.public-session.point-end')}}: {{ getTimeEndPoint(point) }}</span>
        </div>
        <div>
            <span :class="[lvl === 0 ? 'box__title' : 'box__titlechildren', { 'box--takenoff': point.is_taken_off }]">{{filterIndex(point, lvl)}} {{ point.name }}</span>
        </div>
        <div v-if="point.reporter_name != null && point.reporter_name.length > 0" class="referer">
            <span>{{$t('com.file.public-session.referer')}}: <b>{{point.reporter_name}}</b></span>
        </div>
    </section>
</template>

<script charset="utf-8">
import moment from "moment";
import PointsNumerationHelper from "@/helpers/pointsNumeration.helper";

export default {
    name: "PointInformationPublicModal",
    data() {
        return {

        };
    },
    props: {
        point: Object,
        lvl: Number,
        numerations: Object
    },
    methods: {
        getTimeEndPoint(item) {
            if (item.is_done) {
                return moment(item.done_at).format("DD-MM-YYYY, HH:mm");
            }
        },
        filterIndex(agendaItem, level) {
            return PointsNumerationHelper.filterIndex(agendaItem.orderToDisplay, agendaItem.number, level, this.numerations.agenda_number_format_1_id, this.numerations.agenda_number_format_2_id, this.numerations.agenda_number_format_3_id);
        },
    }
};
</script>

<style lang="scss" scoped>

    .referer {
        font-weight: normal;
        font-size: 18px;
        color: #333956;
        padding-top: 15px;
    }

    .point-is-done {
        font-size: 14px;
        height: 30px;
        float: right;
        min-width: 180px;
        text-align: right;

        &__img {
            margin-right: 5px;
            vertical-align: middle;
        }
    }

    .box {
        background: #ffffff;
        width: 100%;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 6px 6px 24px rgba(0, 8, 44, 0.03);
        border-radius: 12px;
        margin-bottom: 12px;
        transition: all 0.2s ease-in-out;

        &__title {
            font-size: 1.7em;
            font-weight: 500;
            margin-right: 16px;
            //font-size: 16px;
            line-height: 132%;
            color: #00082c;
            overflow-wrap: break-word;
            word-break: break-word;
        }

        &__top {
            //display: flex;
            align-items: center;
            padding: 12px;
            justify-content: space-between;
            font-size: 16px;
        }

        &__active {
            align-items: center;
            padding: 29px;
            justify-content: space-between;
            border: 1px solid green;
            background: #f7fff7;
            border-radius: 12px;
            font-size: 24px;
        }

        &--takenoff {
            text-decoration: line-through !important;
        }
    }

    .box-children {
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 6px 6px 24px rgba(0, 8, 44, 0.03);
        border-radius: 12px;
        margin: 12px 12px 0px 32px;
        transition: all 0.2s ease-in-out;

        &__titlechildren {
            margin-left: 32px;
            line-height: 132%;
            color: #00082c;
            text-align: justify;
            word-break: break-word;
            white-space: normal;
            font-size: 1.6em;
            font-weight: 500;
        }
    }

</style>